// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d6373106","404":"92ec3d42"}[chunkId] + ".chunk.js";
};